import Vue from 'vue';
import {
  toast,
  modal,
  Button,
  ButtonLine,
  ButtonGroup,
  Cell,
  CellLeft,
  CellRight
} from '@mx/vix';

[Button, ButtonLine, ButtonGroup, Cell, CellLeft, CellRight].map((c) =>
  Vue.use(c)
);

export { toast, modal };

export * from './env';
export * from './api';
export * from './monitor';
export * from './bridge';
export * from './lxInstall';
export * from './catInstall';
